'use client'

import { ReactElement, ReactNode } from 'react'

import Button from 'shared/ui/Button'
import { Tooltip } from 'shared/ui/Tooltip'
import { addTestId } from 'shared/utils/tests'

import styles from './CartSummaryDisabledButton.module.scss'

export const CartSummaryErrorTooltip = ({
  errors,
  children
}: {
  errors: string[]
  children: ReactElement
}) => (
  <Tooltip
    id='cart-checkout-button-tooltip-errors'
    title={
      <div className={styles.tooltipContent} tabIndex={0}>
        {errors?.map((error: string) => (
          <div key={error}>- {error}</div>
        ))}
      </div>
    }
  >
    {children}
  </Tooltip>
)

interface CartSummaryDisabledButtonProps {
  errors: string[]
  id: string
  loading: boolean
  testTag: string
  endIcon?: ReactElement
  children: ReactNode
}

export const CartSummaryDisabledButton = ({
  errors,
  id,
  loading,
  testTag,
  endIcon,
  children
}: CartSummaryDisabledButtonProps) => {
  const errorLabel = errors
    ? `(wyłączony: ${errors.join(', ')})`
    : undefined

  return (
    <CartSummaryErrorTooltip errors={errors}>
      <div>
        <Button
          className={styles.proceedButton}
          id={id}
          variant='primary'
          size='large'
          fullWidth
          disabled
          loading={loading}
          aria-label={errorLabel}
          {...addTestId(testTag)}
          endIcon={endIcon}
        >
          {children}
        </Button>
        <div className={styles.mobileErrorMessage}>
          {errors.map((error: string) => (
            <div key={error}>- {error}</div>
          ))}
        </div>
      </div>
    </CartSummaryErrorTooltip>
  )
}
